import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/project-summary-skeleton.tpl.svg';

export const ProjectSummarySkeleton = () => <AppSkeletonImage src={imgSVG} />;
